import React from 'react';

const HomePage = () => {
  return (
    <div className="page-section first-section-logo" style={{ padding: '0rem' }}>
      <div className="container-fluid">
        <div className="container">   
          <div className="row">
            <div className="col-12 d-flex flex-column justify-content-between">
              <div className="py-3 d-flex justify-content-start">
                <img style={{ maxWidth: '200px', width: '50%' }} 
                     src="/images/logo.jpg" 
                     alt="Logo" 
                     className="img-fluid" 
                     loading="eager" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid h-100 first-section-background" 
           style={{ 
             background: 'linear-gradient(to bottom, #5de0e6, #004aad)', 
             display: 'flex', 
             alignItems: 'center', 
             justifyContent: 'center' 
           }}>
        <div className="container h-100" style={{ position: 'relative' }}>
          <div className="row h-100 d-flex align-items-center">
            <div className="col-md-6 text-white text-center h-100 d-flex align-items-center justify-content-center">
              <h1 className="text-center" style={{ fontStyle: 'italic', fontSize: '3rem', fontWeight: 'bold', lineHeight: 'unset' }}>
                Vâng, <br /> đảo ngược quá trình lão hóa <br /> là hoàn toàn có thể!
              </h1>
            </div>
            <div className="col-md-6 text-center h-100" style={{ overflow: 'visible' }}>
              <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src="/images/person1.png"
                  alt="Product"
                  style={{ height: '100%', width: 'auto', maxWidth: '100vw', objectFit: 'contain' }}
                  loading="eager" />
              </div>
            </div>
            <div className="col-md-12 text-center" style={{ position: 'absolute', bottom: '3rem', left: 0, right: 0 }}>
              <button className="btn btn-primary btn-buy-now mt-4"
                style={{ padding: '0.48rem 3.8rem' }}
                onClick={() => window.location.href = '#page-section-1'}>
                Tìm hiểu thêm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage; 